import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { SessionData } from '@core/models/auth.model';
import { StoreService } from '@core/store/store.service';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HelperService } from '@shared/services/helper.service';

@Component({
  selector: 'app-account-selection',
  templateUrl: './account-selection.component.html',
  styleUrls: ['./account-selection.component.scss'],
  imports: [CommonModule, TranslateModule]
})
export class AccountSelectionComponent implements OnInit {
  public session: SessionData;
  
 // header = 'REGISTRATION_PAGE.accountTypeSection.obpsAccountRegistration';
  @Input() header: string;
  @Input() thankyoumessage: string;
  message :string;
  createNewAccount = false;

  @Input()sub_header :string;

  constructor(
    private store: StoreService,
    private router: Router,
    private helperService: HelperService,
  ) {
   }

  ngOnInit() {
    this.message = this.thankyoumessage? this.thankyoumessage : 'REGISTRATION_PAGE.authAccountSelection.placeHolderText';
    this.session = this.store.getSession();
   
  }

  goToChooserPage() {
    this.router.navigate(this.helperService.getTranslatedPath('/register/chooser-page'));
  }

  goToWelcomePage() {
    this.router.navigate(this.helperService.getTranslatedPath('/welcome'));
  }

}
